import { COUNTRY_CODE_PATTERN } from '~/utils/localePattern';

const REDIRECT_INFO_REGEX = new RegExp(`^\\/(${COUNTRY_CODE_PATTERN}-[a-z]{2})\\/redirect-info\\/.+`, 'i');
export default defineNuxtRouteMiddleware((to) => {
    const redirectInfoMatch = to.path.match(REDIRECT_INFO_REGEX);
    if (redirectInfoMatch) {
        const prefix = redirectInfoMatch[1];
        log.debug(
            `[middleware-section-redirect.global.ts] Matched redirect-info route with prefix: ${prefix}. Redirecting to clean path.`
        );
        return navigateTo(
            { path: `/${prefix}/redirect-info`, query: to.query, hash: to.hash },
            { redirectCode: 302, replace: true }
        );
    }

    const locale = parseLocaleFromPath(to.path);
    if (locale?.country && locale.language) {
        const { $subSectionRegistry } = useNuxtApp();
        const prefix = `${locale.country}-${locale.language}`;

        if (
            locale.language !== 'de' &&
            isRestrictedSectionPath($subSectionRegistry.value, to.path, useCountryLanguages())
        ) {
            log.debug(
                `[middleware-section-redirect.global.ts] Matched section route with non-DE prefix: ${prefix}. Redirecting to redirect-info path.`
            );
            return navigateTo(
                { path: `/${prefix}/redirect-info`, query: to.query, hash: to.hash },
                { redirectCode: 302, replace: true }
            );
        }
    }
});
